<template>
  <div
    class="member-community"
    :class="{ 'ts-style': $identity.name != 'student' }"
  >
    <el-tabs
      class="el-tabs-common mtabs"
      v-model="activeTab"
      @tab-click="onClickTab"
    >
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div class="tab-content">
      <template v-if="activeTab != 3">
        <CommunityCircleItem
          @complaint="onComplaint"
          :active="activeTab"
          :origin="origin"
          isMcommunity
        ></CommunityCircleItem>
      </template>
      <div v-else class="my-group">
        <el-card
          class="my-group-item"
          shadow="hover"
          v-for="(item, index) in myGroupList"
          :key="index"
          @click.native="onToGroup(item)"
        >
          <img class="icon" :src="item.image" alt="" />
          <div class="right-box">
            <p class="name">{{ item.name }}</p>
            <p class="number">
              <span>贴子{{ item.post_num }}</span>
              <span>成员{{ item.user_num }}</span>
            </p>
            <p class="btns">
              <span class="btn" @click.stop="onExitGroup(item)">退出</span>
            </p>
          </div>
        </el-card>
      </div>
      <el-pagination
        class="pager"
        background
        @current-change="onCurrentChange"
        :current-page="page"
        :page-size="limit"
        layout="prev, pager, next"
        :total="total"
        v-if="total > 10 && activeTab == 3"
      ></el-pagination>
      <Complaint ref="complaint"></Complaint>
      <EmptyNew
        class="empty"
        title="暂无内容~"
        v-if="total == 0 && activeTab == 3"
      />
    </div>
  </div>
</template>

<script>
import CommunityCircleItem from "@/components/community/components/CommunityCircleItem";
import Complaint from "./components/Complaint.vue";
import EmptyNew from "@/components/EmptyNew.vue";
import { triggerLoaded } from "@/components/LoadContainer.vue";

export default {
  name: "MemberCommnunity",
  components: { CommunityCircleItem, Complaint, EmptyNew },
  data() {
    return {
      activeTab: this.$route.query.tab || "0",
      tabs: [
        { name: "0", label: "我发表的" },
        { name: "1", label: "我参与的" },
        { name: "2", label: "我收藏的" },
        { name: "3", label: "我加入的" },
      ],
      myGroupList: [], //我加入的圈子
      page: 1,
      limit: 10,
      total: 0,
      origin: "2", //1:班级圈子 2:社区
    };
  },
  async created() {
    if (this.activeTab == 3) {
      await this.getMyGroup();
    }
    setTimeout(() => {
      triggerLoaded(this);
    }, 0);
  },
  methods: {
    // on event
    async onClickTab(tab) {
      this.activeTab = tab.name;
      if (tab.name == 3) {
        this.getMyGroup();
      }
    },
    async onCurrentChange(page) {
      this.page = page;
      await this.requestList();
    },
    //我加入的圈子
    async getMyGroup() {
      const data = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/myGroup`,
        {
          page: this.page,
          limit: this.limit,
          group_type: this.origin,
        },
      );
      this.total = data.total;
      this.myGroupList = data.data;
    },
    onToPost(item) {
      this.$router.push({
        name: "CommunityShow",
        params: { id: item.post_id },
        query: {
          group_id: item.group_id,
          routeName: "MemberCommunity",
          routeLabel: "我的圈子",
          tab: this.activeTab,
        },
      });
    },
    onToGroup(item) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id: item.group_id || item.id },
        query: {
          routeName: "MemberCommunity",
          routeLabel: "我的圈子",
          tab: this.activeTab,
        },
      });
    },
    async onExitGroup(item) {
      await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/outGroup/${
          item.id
        }`,
      );
      this.$success("退出圈子成功");
      await this.getMyGroup();
    },
    async onCancelCollect(item) {
      await this.$http.put(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect/${
          item.collect_id
        }`,
      );
      this.$success("取消收藏成功");
      await this.getMyGroup();
    },
    async deleteCommunity() {
      //删除帖子成功，刷新
      await this.requestList();
    },
    onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.member-community {
  background: #fff;
  padding: 0 24px 24px 24px;
  &.ts-style {
    padding: 0 24px 1px;
  }
  .mtabs {
    padding-top: 12px;
  }
  .tab-content {
    padding: 0;
    margin-top: -12px;
    // .my-group {
    //   margin-top: 24px;
    // }
    .my-group-item {
      border-radius: 4px;
      width: 288px;
      box-sizing: border-box;
      display: inline-block;
      margin-right: 20px;
      margin-top: 24px;
      cursor: pointer;
      border: 1px solid #e5e5e5 !important;
      &:nth-child(3n) {
        margin-right: 0;
      }
      /deep/ .el-card__body {
        padding: 20px;
        display: flex;
        .icon {
          width: 72px;
          height: 72px;
          border-radius: 4px;
          flex: none;
          margin-right: 16px;
        }
        .right-box {
          .name {
            font-size: 14px;
            font-weight: 600;
            color: #333;
          }
          .number {
            font-size: 13px;
            color: #999;
            margin-top: 4px;
            span {
              margin-right: 12px;
            }
          }
          .btn {
            display: inline-block;
            margin-top: 10px;
            color: $primary-color;
            cursor: pointer;
          }
        }
      }
    }
    .my-group-item-no-bottom {
      margin-bottom: 0;
    }
    .my-collect-item {
      border-radius: 10px;
      margin-bottom: 25px;
      cursor: pointer;
      /deep/ .el-card__body {
        overflow: hidden;
        .btn-collect {
          width: 12px;
          height: 12px;
          float: right;
        }

        .user {
          display: flex;
          .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 12px;
            flex: none;
          }
          .right-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .nickname {
              font-size: 15px;
              font-weight: 500;
              color: #20242a;
            }
            .datetime {
              font-size: 12px;
              font-weight: 500;
              color: #8c8c8c;
              margin-right: 20px;
            }
            .from {
              font-size: 12px;
              font-weight: 500;
              color: #8c8c8c;
              .group {
                color: $primary-color;
              }
            }
          }
        }
        .detail {
          padding: 15px 0;
          font-weight: 500;
          .title {
            font-size: 19px;
            color: #20242a;
            margin-bottom: 8px;
          }
          .content {
            font-size: 14px;
            color: #8c8c8c;
          }
        }
        .number {
          font-size: 12px;
          font-weight: 500;
          color: #8c8c8c;
          float: right;
          .number-item {
            margin-left: 24px;
            i {
              width: 11px;
              height: 11px;
              display: inline-block;
              margin-right: 5px;
            }
            .icon-like {
              background: url("~@/assets/images/icon_fourm_zan.png") no-repeat
                center/contain;
            }
            .icon-comment {
              background: url("~@/assets/images/icon_fourm_comment.png")
                no-repeat center/contain;
            }
            .icon-browse {
              background: url("~@/assets/images/icon_fourm_browse.png")
                no-repeat center/contain;
              width: 13px;
              height: 13px;
            }
          }
        }
      }
    }
    /deep/ .el-pagination {
      margin: 0;
    }
  }
}
</style>
